import { IInfoAdicional } from 'pages/pagamento/pagamento.model';
import { IAbstractModel } from "model/abstract.model";
import { IEstabelecimento } from "model/estabelecimento.model";
import { GenericTO } from "model/generic.model";
import { TAcenumDTO } from "pages/Configuracoes/ConfigurarMovimentacaoFiscal";

export enum FinancasTitle {
    GESTAO_DO_RECEBER = "Gestão do recebimento",
    GESTAO_DO_PAGAMENTO = "Gestão do pagamento"
}

export const headerWidthsBck = {
    descricao: "20%",
    parcela: "5rem",
    emissao: "10rem",
    vencimento: "10rem",
    valor: "10rem",
    status: "5rem",
    formaPagamento: "10rem",
    action: "10rem"
};

export const headerWidths = {
    checkBox: "5%",
    isContaVencida: "5%",
    possuiVinculo: "5%",
    isBoletoOuRemessa: "5%",
    descricao: "25%",
    documento: "5%",
    parcela: "5%",
    emissao: "5%",
    vencimento: "5%",
    valor: "5%",
    status: "5%",
    formaPagamento: "10%",
    action: "5%"
};
export type FlowContaReceberDTO = {
    uuid: string,
    descricao: string,
    documento: string,
    parcela: string,
    emissao: string,
    vencimento: string,
    valor: number;
    valorAberto: number,
    status: StatusContaPagarReceber,
    formaPagamento: string;
    vencido: boolean;
    imprimeBoleto: boolean;
    possuiVinculo: string | null;
    parcelaBoletoGerado: string | null;
    modalidade: string | null
}

export enum StatusContaPagarReceber {
    ABERTA = "ABERTA",
    PARCIAL = "PARCIAL",
    BAIXADA = "BAIXADA",
    CANCELADA = "CANCELADA"
}

export enum TipoContaReceberFiltro {
    EMISSAO = "EMISSAO",
    VENCIMENTO = "VENCIMENTO"
}

export type TVisualizarContasReceberProps = {
    onClose: () => void;
    uuid: string;
}

export enum VisualizarContaReceberRender {
    IDENTIFICACAO = "IDENTIFICAÇÃO",
    DADOS_COBRANCA = "DADOS COBRANÇA",
    DADOS_CHEQUE = "DADOS CHEQUE",
    DADOS_BAIXA = "DADOS BAIXA",
    DADOS_RECEBIMENTO = "DADOS RECEBIMENTO",
    HISTORICO_MOVIMENTACAO = "HISTÓRICO MOVIMENTAÇÕES",
    REPRESENTANTES = "REPRESENTANTES",
    HISTORICO_ALTERACAO_VENCIMENTO = "HISTÓRICO ALTERAÇÕES VENCIMENTOS",
    CONTAS_APROPRIACOES = "CONTAS APROPRIAÇÕES",
    OBSERVACAO = "OBSERVAÇÃO"
}

export enum TDadosBaixaHeader {
    DATA_BAIXA = "Data da baixa",
    CONTA_FINANCEIRA = "Conta financeira",
    FORMA_PAGAMENTO = "Forma de pagamento",
    VALOR = "Valor",
    MULTA = "Multa",
    JUROS = "Juros",
    DESCONTO = "Desconto",
    TOTAL = "Total"
}

export type TVisualizarItemProps = {
    title: string,
    item: string | number | undefined,
    marginTop?: string;
    marginLeft?: string;
    noFontweight?: boolean
}

export type FlowContaReceberIdentificacaoDTO = {
    descricao: string;
    pessoa: string;
    numeroDocumento: string;
    parcela: string;
    formaPagamento: string;
    tipo: string;
    status: StatusContaPagarReceber
    emissao: string;
    vencimento: string;
    valor: number;
    valorAberto: number;
}

export type FlowContaReceberDadosChequeDTO = {
    contaFinanceiraOrigem: string;
    contaFinanceiraAtual: string;
    banco: string;
    agencia: string;
    numero: string;
    emitente: string;
    situacao: string;
    dataRecebimento: string
}

export type FlowContaReceberDadosRecebimentoCartaoDTO = {
    credenciadora: string,
    bandeira: string,
    modoPagamento: string,
    nsu: string,
    numeroControle: string,
    codigoAutorizacao: string,
    numeroTerminal: string,
    situacao: string,
    dataRecebimento: string,
    valor: string,
    baixasOrigem: Array<FlowContaReceberRelacionadaComRecebimentoCartaoDTO>
}

export type FlowContaReceberRelacionadaComRecebimentoCartaoDTO = {
    descricao: string;
    parcela: string;
    emissao: string;
    vencimento: string;
    valor: string;
    status: string
}

export type FlowContaReceberChequeRecebidoDTO = {
    banco: string | null;
    agencia: string | null;
    numero: string | null;
    emitente: string | null;
    situacao: string | null;
    dataRecebimento: string | null
}

export type FlowContaReceberDadosRecebimentoItensDTO = {
    uuid: string | null;
    descricao: string;
    parcela: string;
    emissao: string;
    vencimento: string;
    valor: string;
    status: string;
    dadosCheque: FlowContaReceberChequeRecebidoDTO | null
}

export type FlowContaReceberCartaoDTO = {
    uuid: string;
    credenciadora: string;
    bandeira: string;
    modoPagamento: string;
    nsu: string;
    numeroControle: string;
    situacao: string;
    data: string;
    valor: string;
    contasGeradas: Array<FlowContaReceberDadosRecebimentoItensDTO>
}

export type FlowContaReceberDadosRecebimentoDTO = {
    dadosRecebimentoCartao: FlowContaReceberDadosRecebimentoCartaoDTO,
    dadosRecebimentoItens: Array<FlowContaReceberDadosRecebimentoItensDTO>
    recebimentos: Array<FlowContaReceberCartaoDTO>
}

export type FlowContaReceberBaixa = {
    dataBaixa: string;
    contaFinanceira: string | null;
    formaPagamento: string | null;
    valor: string;
    multa: string;
    juros: string;
    desconto: string;
    total: string
}

export type FlowContaReceberDadosCobrancaDTO = {
    posicaoCobranca: string;
    situacaoBoleto: string;
    situacaoCobranca: string;
    cobrancaBancaria: string;
    modalidade: string;
    contaCorrente: string;
    nossoNumero: string
}

export type FlowHistoricoMovimentacaoDTO = {
    lancamento: string;
    tipoMovimento: string;
    valor: number;
    multa: number;
    juros: number;
    desconto: number;
    tarifa: number;
    total: number;
    usuario: string;
    data: string
}

export type FlowContaReceberHistoricoMovimentacoesDTO = {
    historicos: Array<FlowHistoricoMovimentacaoDTO>
}

export type FlowContaReceberOutrosComissionadosDTO = {
    representante: string;
    formaComissao: string;
    papel: string;
}

export type FlowContaReceberRepresentantesDTO = {
    representante: string;
    formaComissao: string;
    outrosComissionados: Array<FlowContaReceberOutrosComissionadosDTO>
}

export type FlowHistoricoAlteracaoMovimentoDTO = {
    tipo: string;
    vencimentoAnterior: string;
    vencimentoNovo: string;
    usuario: string;
    data: string;
}

export type FlowContaApropriacaoDTO = {
    conta: string;
    valor: number
}

export type FlowContaReceberContasApropriacoesDTO = {
    contas: Array<FlowContaApropriacaoDTO>
}

export type FlowContaReceberHistoricoAlteracaoVencimentoDTO = {
    historicos: Array<FlowHistoricoAlteracaoMovimentoDTO>
}

export type FlowContaReceberVisualizacaoDTO = {
    identificacao: FlowContaReceberIdentificacaoDTO,
    dadosCobranca: FlowContaReceberDadosCobrancaDTO,
    dadosCheque: FlowContaReceberDadosChequeDTO | null,
    dadosRecebimento: FlowContaReceberDadosRecebimentoDTO | null,
    dadosBaixa: Array<FlowContaReceberBaixa>,
    historicoMovimentacoes: FlowContaReceberHistoricoMovimentacoesDTO,
    representantes: FlowContaReceberRepresentantesDTO,
    historicoAlteracaoVencimentos: FlowContaReceberHistoricoAlteracaoVencimentoDTO,
    contasApropriacoes: FlowContaReceberContasApropriacoesDTO,
    observacao: string | null
}

export const initialFlowContaReceberVisualizacaoDTO: FlowContaReceberVisualizacaoDTO = {
    identificacao: {
        descricao: "",
        emissao: "",
        formaPagamento: "",
        numeroDocumento: "",
        parcela: "",
        pessoa: "",
        status: StatusContaPagarReceber.ABERTA,
        tipo: "",
        valor: 0,
        valorAberto: 0,
        vencimento: ""
    },
    dadosCobranca: {
        cobrancaBancaria: "",
        contaCorrente: "",
        modalidade: "",
        nossoNumero: "",
        posicaoCobranca: "",
        situacaoBoleto: "",
        situacaoCobranca: ""
    },
    dadosCheque: {
        contaFinanceiraOrigem: "",
        contaFinanceiraAtual: "",
        banco: "",
        agencia: "",
        numero: "",
        emitente: "",
        situacao: "",
        dataRecebimento: ""

    },
    dadosRecebimento: null,
    dadosBaixa: [],
    historicoMovimentacoes: {
        historicos: []
    },
    representantes: {
        formaComissao: "",
        representante: "",
        outrosComissionados: []
    },
    historicoAlteracaoVencimentos: {
        historicos: []
    },
    contasApropriacoes: {
        contas: []
    },
    observacao: ""

}

export type TBaixarContaReceberProps = {
    onClose: () => void;
    onCloseReturning: (baixados: Array<FlowContaReceberDTO>) => void;
    uuid: string | null;
    uuids: Array<FlowContaReceberDTO>,
    contasFinanceiras: Array<GenericTO>
}

export type FlowContaBaixaDTO = {
    uuid: string;
    formaPagamentoUUID: string;
    descricao: string;
    parcela: string;
    vencimento: string;
    valorAberto: number;
    valorRecebido: number;
    multa: number;
    juros: number;
    desconto: number;
    totalRecebido: number
}

export type FlowBaixaContaReceberDadosDTO = {
    formaPagamentoUUID: string | null;
    contaFinanceiraUUID: string | null;
    credenciadora: string | null;
    bandeira: string | null;
    modoPagamento: string | null;
    nsu: string | null;
    numControle: string | null;
}

export type FlowBaixaContaReceberDTO = {
    flowBaixaContaReceberDadosDTO: FlowBaixaContaReceberDadosDTO,
    flowContaBaixasDTO: Array<FlowContaBaixaDTO>,
    dataLancamento: string | null;
    infoAdicionalTO: IInfoAdicional
}

export type TContasBaixar = "multa" | "juros" | "desconto" | "valorRecebido"

export type Intervalo = {
    inicio: string | null;
    fim: string | null;
}

export enum SitacaoCheque {
    CARTEIRA = "CARTEIRA",
    TERCEIRO = "TERCEIRO",
    COMPENSADO = "COMPENSADO",
    DEVOLVIDO = "DEVOLVIDO",
    TROCADO = "TROCADO",
    DEPOSITADO = "DEPOSITADO"
}

export type filtroCartaoDTO = {
    nsus: Array<string>;
    numerosControle: Array<string>;
}

export type filtroChequeDTO = {
    banco: IAbstractModel | null,
    agenciaCheque: string | null;
    numeroCheque: string | null;
    situacoesCheque: Array<SitacaoCheque>,
    chequeComTerceiro: IAbstractModel | null
}

export type FiltroAvancadoContaReceberDTO = {
    descricao: string;
    pessoa: IAbstractModel | null;
    numeroDocumentos: Array<string>;
    numeroParcela: string;
    emissao: Intervalo;
    vencimento: Intervalo;
    baixa: Intervalo;
    estabelecimentos: Array<IEstabelecimento>
    formasPagamento: Array<IAbstractModel>;
    statusParcela: Array<StatusContaPagarReceber>;
    filtroCartaoDTO: filtroCartaoDTO,
    filtroChequeDTO: filtroChequeDTO,
    pageNumber: number;
    pageSize: number
}

export enum TDataState {
    EMISSAO = "emissao",
    VENCIMENTO = "vencimento",
    BAIXA = "baixa"
}

export enum TDataStateField {
    INICIO = "inicio",
    FIM = "fim"
}

export type TFiltroAvancadoOptions = {
    pessoa: Array<IAbstractModel>;
    status: Array<StatusContaPagarReceber>,
    bancos: Array<IAbstractModel>,
    situacoesCheque: Array<TAcenumDTO>
}

export type TFiltroAvancadoContasReceberProps = {
    filtroAvancado: FiltroAvancadoContaReceberDTO;
    filtroAvancadoOptions: TFiltroAvancadoOptions;
    filtroDescricao: string;
    filtroParcela: string;
    formasPagamento: Array<IAbstractModel>,
    formasPagamentoSelecionado: Array<IAbstractModel>,
    onInputChangePessoa: (value: string) => void;
    onResetFiltroPessoa: () => void
    onConsultar: (filtroAvancado: FiltroAvancadoContaReceberDTO) => void;
    onClose: () => void;
    onRemoveFormaPagamentoChip: (formasPagamentoRestantes: Array<IAbstractModel>) => void
}

export type TContaReceberCheckBox = {
    uuid: string,
    modalidade: string | null
}

export type FlowContaReceberRecebimentoChequeExclusao = {
    descricao: string;
    parcela: string;
    vencimento: string;
    status: string;
    valorParcela: string;
}

export type FlowContaReceberBaixasContaFinanceiraDTO = {
    descricao: string;
    parcela: string;
    vencimento: string;
    status: string;
    valorParcela: string;
    multa: string;
    juros: string;
    desconto: string;
    totalPago: string;
    recebimentoEmCheque: Array<FlowContaReceberRecebimentoChequeExclusao> | null
}

export type FlowContaReceberBaixasCompensacaoContaDTO = {
    descricao: string;
    parcela: string;
    vencimento: string;
    status: string;
    valorParcela: string;
    valorBaixado: string;
    lancamento: string;
    historico: string;
    valor: string;
}

export type FlowContaReceberBaixaDTO = {
    uuid: string;
    lancamento: string;
    contaFinanceira: string | null;
    historico: string | null
    valor: string;
    baixaContaFinanceira: FlowContaReceberBaixasContaFinanceiraDTO
    baixaCompensacaoConta: FlowContaReceberBaixasCompensacaoContaDTO;
    cheque: boolean;
    disabled: boolean
}

export type FlowContaReceberExclusaoDTO = {
    descricao: string;
    parcela: string;
    vencimento: string;
    valor: string;
    baixas: Array<FlowContaReceberBaixaDTO>
}